module.exports = __webpack_public_path__ + "media/images/flags/hm-195dffaad4cca86c6223685a34ce3514.svg";